/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".progress-bar[_ngcontent-%COMP%]{top:8px}.loader-container[_ngcontent-%COMP%]{position:fixed;z-index:2000;top:10%;width:350px;margin-left:40%;background-color:#fdfdfd;padding:25px;border:1px solid #ebebeb}"];
export { styles as styles };
